import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileDropdown.css';

const ProfileDropdown = ({ user, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getInitials = (name) => {
    if (!name) return 'A';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <button
        className="profile-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Profile menu"
      >
        <div className="profile-avatar">
          {getInitials(user?.name || 'Admin')}
        </div>
        <span className="profile-name">{user?.name || 'Admin'}</span>
        <span className="profile-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className="profile-menu">
          <div className="profile-menu-header">
            <div className="profile-avatar-large">
              {getInitials(user?.name || 'Admin')}
            </div>
            <div className="profile-details">
              <div className="profile-details-name">{user?.name || 'Admin'}</div>
              <div className="profile-details-email">{user?.email || ''}</div>
              <div className="profile-details-role">{user?.role || ''}</div>
            </div>
          </div>
          <div className="profile-menu-divider"></div>
          <button
            className="profile-menu-item"
            onClick={() => {
              setIsOpen(false);
              // Add profile settings page later
            }}
          >
            <span>⚙️</span> Profile Settings
          </button>
          <button
            className="profile-menu-item"
            onClick={() => {
              setIsOpen(false);
              // Add change password page later
            }}
          >
            <span>🔒</span> Change Password
          </button>
          <div className="profile-menu-divider"></div>
          <button className="profile-menu-item logout" onClick={onLogout}>
            <span>🚪</span> Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;


















